import { useQuery } from "@tanstack/react-query";
import { User } from "@/common/types";
import { axiosInstance } from "../../axios";

const getUserMe = async () => {
  return await axiosInstance
    .get("user/me")
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      throw e;
    });
};

const useGetUserMe = () => {
  return useQuery<User>({
    queryKey: ["user", "me"],
    queryFn: () => getUserMe(),
  });
};
export default useGetUserMe;
